<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import ActionMenuDropdown from "@/components/ActionMenu/ActionMenuDropdown.vue";
import { cardKey } from "@/components/StickyNote/injectKeys";
import {
  cardWasCreatedOnDifferentBoard,
  isActionVisible,
} from "@/components/StickyNote/internal/ActionMenu/actions";
import { boardKey } from "@/components/board/injectKeys";
import { injectStrict } from "@/utils/vue";

import ChangeProject from "./ChangeProject.vue";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);
const isVisible = computed(
  () =>
    isActionVisible("almSource", card, board.value) &&
    !cardWasCreatedOnDifferentBoard(card, board.value) &&
    board.value.almSources.length > 1,
);
</script>

<template>
  <ActionMenuDropdown v-if="isVisible" :action="cardActions.setAlmSource">
    <ChangeProject />
  </ActionMenuDropdown>
</template>
